<template>
  <v-form v-model="valid" ref="mainForm">
    <ressource v-show="!sasDispenseDeFormation.exercePsychoterapie" code="avertissement-pratique-psyt"></ressource>

    <opq-catalogue code="dispense-motif" v-model="sasDispenseDeFormation.motifDeDispense" :live="liveSasDispenseFormation(13902)"></opq-catalogue>
    <opq-date-picker
      code="dispense-debut"
      v-model="sasDispenseDeFormation.debutDeDispense"
      :live="liveSasDispenseFormation(13903)"
      :minYear="2017"
    ></opq-date-picker>
    <opq-date-picker
      code="dispense-fin"
      v-model="sasDispenseDeFormation.finDeDispense"
      :live="liveSasDispenseFormation(13904)"
      :minYear="2017"
      optional
    ></opq-date-picker>
    <opq-memo code="dispense-infos" v-model="sasDispenseDeFormation.informationsSupplementaires" :live="liveSasDispenseFormation(13905)"></opq-memo>
    <opq-file-multiple code="dispense-fichiers" :files="sasDispenseDeFormation.piecesJustificatives" :live="liveSasDispenseFormation(13906)">
    </opq-file-multiple>
    <opq-case code="dispense-declaration" v-model="sasDispenseDeFormation.declaration" :live="liveSasDispenseFormation(13907)"> </opq-case>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasDispenseDeFormation() {
      return this.sas.sasDispenseDeFormation
    }
  },

  methods: {
    liveSasDispenseFormation(cle) {
      return { endpoint: "/sas-dispense-formation/", cle: cle, fileId: this.sasDispenseDeFormation.id }
    }
  }
}
</script>

<style>
</style>